import { Box, Banner } from '@fullstory/components';
import React from 'react';
import { FormattedDateTimeRange, FormattedMessage } from 'react-intl';
import { FilteredTimeRanges } from '../../utils/privacy';

const defaultWarningText = (
  <FormattedMessage
    defaultMessage="The results for this search contain sessions that have been deleted by your organization's
                    administrator and cannot be viewed."
    id="L8VLRR"
  />
);

export const metricTimeRangeWarningText = (
  <FormattedMessage
    defaultMessage="These results contain data that has been deleted by your organization's administrator and
                    cannot be viewed."
    id="MeenWr"
  />
);

export const GenericTimeRangeFilterText: React.FC<{
  filteredTimeRanges: FilteredTimeRanges[];
}> = ({ filteredTimeRanges }) => (
  <Box data-component="GenericTimeRangeFilterText" paddingLeft={8}>
    <FormattedMessage
      defaultMessage="Data in the following time ranges have been deleted by your organization's administrator
                      and cannot be viewed:"
      id="7RRdpS"
    />
    <br />
    {filteredTimeRanges.map((d, i) => (
      <>
        <FormattedDateTimeRange
          from={d.startTime}
          to={d.endTime}
          dateStyle="long"
          timeStyle="short"
        />
        {i != filteredTimeRanges.length - 1 ? <br /> : ''}
      </>
    ))}
  </Box>
);
export const DynamicTimeRangeWarning: React.FC<{ warningText?: React.ReactNode }> = ({
  warningText = defaultWarningText,
}) => (
  <Banner data-component="DynamicTimeRangeWarning" variant="warning" description={warningText} />
);
